module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "fi-pc aboutus-container"
  }, [_c('div', {
    staticClass: "fi-main"
  }, [_c('fi-header'), _vm._v(" "), _c('div', {
    staticClass: "aboutus"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ab-title ab-l"
  }, [_c('a', {
    attrs: {
      "name": "guyudd"
    }
  }, [_c('h1', [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text",
    attrs: {
      "id": 'anchor-' + 0
    }
  }, [_c('a', {
    attrs: {
      "href": "#anchor-0"
    }
  }, [_vm._v("关于点点")]), _vm._v(" "), _c('p', [_vm._v("About D.Point")])]), _vm._v(" "), _c('div', {
    staticClass: "nr"
  }, [_vm._v("\n                                点点，是由深圳蜂点科技有限公司运营的智能生活金融服务平台，旨为用户提供优质的综合生活与金融连接服务。已与国内众多知名金融机构达成深度合作。\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ab-title ab-l"
  }, [_c('h1', [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text",
    attrs: {
      "id": 'anchor-' + 1
    }
  }, [_c('a', {
    attrs: {
      "href": "#anchor-1"
    }
  }, [_vm._v("点点大事记")]), _vm._v(" "), _c('p', [_vm._v("About D.Point")])]), _vm._v(" "), _c('div', {
    staticClass: "shou-icon"
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ab-title"
  }, [_c('h1', [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text",
    attrs: {
      "id": 'anchor-' + 2
    }
  }, [_c('a', {
    attrs: {
      "href": "#anchor-2"
    }
  }, [_vm._v("点点愿景·一站式金融生活服务平台")]), _vm._v(" "), _c('p', [_vm._v("About Future·A One-stop Financial Service Platform")])]), _vm._v(" "), _vm._m(1)])])], 1), _vm._v(" "), _c('fi-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ab-title ab-r"
  }, [_c('div', {
    staticClass: "js-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gc-icon"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("金融")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("商城")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("生活服务")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("充值缴费")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("休闲娱乐")])]), _vm._v(" "), _c('li', [_c('i'), _vm._v(" "), _c('h2', [_vm._v("线下服务")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30827b1a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AboutUs.vue
// module id = 359
// module chunks = 1